import React, { useState, useEffect, useRef } from 'react';
import { useIsFetching, useIsMutating } from 'react-query';

const STYLES = `
  @keyframes gl-slide {
    0%   { transform: translateX(-100%); }
    100% { transform: translateX(400%); }
  }
  @keyframes gl-fadein  { from { opacity: 0; } to { opacity: 1; } }
  @keyframes gl-fadeout { from { opacity: 1; } to { opacity: 0; } }

  .gl-bar-track {
    position: fixed;
    top: 0; left: 0; right: 0;
    height: 3px;
    z-index: 9999;
    overflow: hidden;
    pointer-events: none;
  }
  .gl-bar-track.gl-in  { animation: gl-fadein  0.1s ease forwards; }
  .gl-bar-track.gl-out { animation: gl-fadeout 0.35s ease forwards; }

  .gl-bar-fill {
    position: absolute;
    top: 0; left: 0;
    width: 35%;
    height: 100%;
    background: linear-gradient(90deg, #f97316, #fb923c, #fdba74);
    border-radius: 0 2px 2px 0;
    box-shadow: 0 0 8px rgba(249, 115, 22, 0.7);
    animation: gl-slide 1.1s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }
`;

export default function GlobalLoader() {
  // React Query observers — guaranteed to fire for every useQuery / useMutation
  const rqFetching = useIsFetching();
  const rqMutating = useIsMutating();

  // Axios interceptor signal — catches any api.js call NOT wrapped in React Query (e.g. login)
  const [axiosActive, setAxiosActive] = useState(false);

  useEffect(() => {
    const handler = (e) => setAxiosActive(e.detail.active);
    window.addEventListener('api-loading', handler);
    return () => window.removeEventListener('api-loading', handler);
  }, []);

  const isActive = rqFetching > 0 || rqMutating > 0 || axiosActive;

  // Keep the bar visible long enough for the fade-out animation to finish
  const [visible, setVisible] = useState(false);
  const hideTimer = useRef(null);

  useEffect(() => {
    clearTimeout(hideTimer.current);
    if (isActive) {
      setVisible(true);
    } else {
      hideTimer.current = setTimeout(() => setVisible(false), 400);
    }
    return () => clearTimeout(hideTimer.current);
  }, [isActive]);

  if (!visible) return null;

  return (
    <>
      <style>{STYLES}</style>
      <div className={`gl-bar-track ${isActive ? 'gl-in' : 'gl-out'}`}>
        <div className="gl-bar-fill" />
      </div>
    </>
  );
}
